import api from "../../utils/apiPublic";

export const getStoreHeaderBranding = async () => {
  const res = await api.get("/api/public/store-branding/header", {
    params: {
      section: "HEADER",
    },
  });
  return res.data;
};

export const getStoreFooterBranding = async () => {
  const res = await api.get("/api/public/store-branding/footer", {
    params: {
      section: "FOOTER",
    },
  });
  return res.data;
};